import { setFullName } from '@/_helpers/utils.js'

const state = {
  loading: false,
  error: null,
  invites: [],
  filters: {
    responseStatusId: null,
    vacancyId: null
  },
  sorting: {
    name: 'date',
    order: 'desc'
  },
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    totalCounts: 0,
    count: 5,
    load_more_pages: 1,
    is_load_more: false
  }
}

const actions = {
  fetch ({ commit, state, dispatch, rootGetters }, { searchTerm }) {
    commit('fetch')

    const filters = state.filters
    const sorting = state.sorting

    let params = {
      search_term: searchTerm
    }

    if (sorting.name) {
      params['sort_by'] = sorting.name
      params['sort_order'] = sorting.order
    }

    if (filters.responseStatusId) {
      params = {
        ...params,
        response_status_id: filters.responseStatusId
      }
    }

    if (filters.vacancyId) {
      params = {
        ...params,
        vacancy_id: filters.vacancyId
      }
    }

    let count = state.pagination.count;

    const is_load_more = state.pagination.is_load_more;

    if (is_load_more) {
      count = (state.pagination.pageNumber * state.invites.length) + state.pagination.count

      params.page = 1;
      params.count = count
    } else {
      params.page = state.pagination.pageNumber
      params.count = state.pagination.count
    }

    return rootGetters['situation/api/invitesAPI'].fetch(params)
      .then(({data, meta}) => {
        commit('fetchSuccess', {data, meta, is_load_more})

        if (is_load_more) {
          commit('set_pagination_more', {count})
        }
      })
      .catch(err => {
        dispatch('global/setError', err, { root: true })
        commit('fetchFailure', err)
      })
  },

  updateFilters ({commit, state, dispatch}, data) {
    commit('updateFilters', data)
    commit('updatePagination', {
      pageNumber: 1
    })

    dispatch('fetch')
  },

  updateSorting ({commit, state, dispatch}, data) {
    commit('updateSorting', data)

    dispatch('fetch')
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {data, meta, is_load_more}) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count)
    }

    const data_with_full_name = data.map(user => {
      if (!user.creator) {
        return user
      }

      return Object.assign({}, user, {
        creator: setFullName(user.creator, 'first_name', 'last_name')
      })
    })
    state.pagination.totalCounts = meta.total
    state.invites = data_with_full_name
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  updateFilters (state, data) {
    const filters = state.filters

    Object.keys(data).forEach((key) => {
      if (!filters.hasOwnProperty(key)) {
        throw new Error(`Unknown filter key ${key}`)
      }
    })

    Object.assign(state.filters, data)
  },

  updateSorting (state, data) {
    Object.assign(state.sorting, data)
  },

  updatePagination (state, params) {
    state.pagination = Object.assign(state.pagination, params)
  },

  set_load_more (state, val) {
    state.pagination = Object.assign(state.pagination, {
      is_load_more: val
    })
  },

  set_pagination_more (state, {count}) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count)
  },

  change_count (state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    })
  },

  clear() {
    state.invites = [];

    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      totalCounts: 0,
      count: 5,
      load_more_pages: 1,
      is_load_more: false
    })
  }
}

const getters = {
  error: state => {
    return state.error;
  },

  sorting: state => {
    return state.sorting;
  },

  filters: state => {
    return state.filters;
  },

  pagination: state => {
    return state.pagination;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
